import { ChangeDetectionStrategy, Component, effect, inject, Inject, signal } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { NgIf } from '@angular/common';
import { Store } from '@ngrx/store';
import { selectOrdersError } from '../../../../@store/orders/orders.selectors';
import { SafeAny } from '../../../../types/safe-any';
import { OrdersActions } from '../../../../@store/orders/orders.actions';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'ciwc-delete-order',
  imports: [
    MatButton,
    MatDialogActions,
    MatDialogContent,
    MatDialogTitle,
    MatProgressSpinner,
    MatIconModule,
    NgIf,
  ],
  standalone: true,
  templateUrl: './delete-order.component.html',
  styleUrl: './delete-order.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteOrderComponent {
  private readonly store = inject(Store);
  readonly error = this.store.selectSignal(selectOrdersError);
  readonly lastAction = this.store.selectSignal(state => state.orders.lastAction);
  isDeleting = signal(false);

  constructor(
    public dialogRef: MatDialogRef<DeleteOrderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { order: SafeAny },
  ) {
    effect(() => {
      if (this.isDeleting()) {
        const error = this.error();
        if (error) {
          this.isDeleting.set(false);
        }
      }
    });

    effect(() => {
      const action = this.lastAction();
      if (action === 'Delete Order Success' && this.isDeleting()) {
        this.isDeleting.set(false);
        this.dialogRef.close({
          success: true
        });
      }
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    this.isDeleting.set(true);
    this.store.dispatch(OrdersActions.deleteOrder({
      orderId: this.data.order.id
    }));
  }
}
